var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowRightWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M1.25 12a.75.75 0 0 1 .75-.75h16.257l-6.378-6.734a.75.75 0 0 1 1.089-1.032L21.033 12l-8.065 8.516a.75.75 0 1 1-1.09-1.032l6.379-6.734H2a.75.75 0 0 1-.75-.75",
  clipRule: "evenodd"
})));
export default SvgIconArrowRightWhite;